<script>
export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
  },
};
</script>

<!-- eslint-disable vue/no-unused-refs -->
<!-- Added ref for writing specs -->
<template>
  <div class="flex flex-col items-start px-8 pt-8 pb-0">
    <img v-if="headerImage" :src="headerImage" alt="No image" />
    <!-- 18px, um degrau ABAIXO do titulo de pagina (24px). Modal e contexto
         aninhado, nao irmao da pagina: com o mesmo tamanho os dois disputam a
         leitura.
         Antes nao havia tamanho declarado aqui e o <h2> caia no padrao do
         navegador (~24px). Cada modal que quis outro tamanho escreveu o seu --
         dai os quatro tamanhos para o mesmo papel (18/20/24/16 em 110 titulos).
         Este componente sozinho cobre 73 dos modais. -->
    <h2
      ref="modalHeaderTitle"
      class="text-lg font-semibold leading-6 text-body"
    >
      {{ headerTitle }}
    </h2>
    <p
      v-if="headerContent"
      ref="modalHeaderContent"
      class="w-full mt-2 text-sm leading-5 break-words text-muted"
    >
      {{ headerContent }}
      <span v-if="headerContentValue" class="text-sm font-semibold text-body">
        {{ headerContentValue }}
      </span>
    </p>
    <slot />
  </div>
</template>
